import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ToastService {

  constructor(
    private readonly toastController: ToastController,
  ) { }

  async simple(message: string, duration = 5000, header?: string): Promise<HTMLIonToastElement> {
    const toast = await this.toastController.create({ message, duration, header });
    await toast.present();
    return toast;
  }

  async persistence(message: string, header?: string): Promise<HTMLIonToastElement> {
    const toast = await this.toastController.create({
      message,
      header,
      icon: 'alert-circle-outline',
      buttons: [{
        icon: 'close',
        side: 'end',
        role: 'cancel',
      }],
    });
    await toast.present();
    return toast;
  }
}
